module.exports = __webpack_public_path__ + "static/media/5-item-b.dbfaf338.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/5-item-b.jpg
// module id = 1173
// module chunks = 33